<template>
    <v-autocomplete
        :items="countryCollection ? countryCollection.models : []"
        :item-text="itemText"
        :item-value="itemValue"
        :label="label"
        dense
        outlined
        v-bind="$attrs"
        v-on="$listeners"
    />
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'CountrySelectField',

    props: {
        itemText: {
            type: String,
            default: 'printable_name',
        },
        itemValue: {
            type: String,
            default: 'iso',
        },
        label: {
            type: String,
            default: function () {
                return this.$t('land');
            },
        },
    },

    computed: {
        ...mapState('country', {
            countryCollection: 'collection',
        }),
    },

    mounted() {
        this.loadCountryData();
    },

    methods: {
        ...mapActions('country', {
            loadCountryData: 'load',
        }),
    },
};
</script>

<style lang="scss" scoped></style>
